import React from 'react';
import { Headline } from '@/types';

interface HeadlineCircleProps {
  headline: Headline;
}

export function HeadlineCircle({ headline }: HeadlineCircleProps) {
  const domain = headline.url ? new URL(headline.url).hostname : '';
  
  return (
    <div
      className="relative inline-block flex-shrink-0"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="h-6 w-6 rounded-full bg-white border border-gray-200 overflow-hidden hover:z-10 transition-transform hover:scale-110">
        <img
          src={`https://www.google.com/s2/favicons?domain=${domain}&sz=32`}
          alt={domain}
          className="w-full h-full object-cover"
          onError={(e) => {
            (e.target as HTMLImageElement).src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"%3E%3Cpath fill="%23666" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/%3E%3C/svg%3E';
          }}
        />
      </div>
    </div>
  );
} 